import { Spin } from 'antd';

const Loading = ({ size = 'large'}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        backgroundColor: '#f0f2f5',
      }}
    >
      <Spin size={size} />
    </div>
  );
};

export default Loading;